module.exports = __webpack_public_path__ + "assets/img/warrior-name-0bdf5385.png";